exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-5ba562ea] .el-card__body{height:100%}.successTextColor[data-v-5ba562ea]{color:var(--tagSuccessText)}.infoText[data-v-5ba562ea]{color:var(--tagInfoText)}", ""]);

// exports
